import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/icons/token.svg'


const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm leading-6 font-semibold tracking-wider text-blue-900" }, " Jumlah Peserta ", -1)
const _hoisted_3 = { class: "text-sm leading-6 text-gray-400" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm leading-6 font-semibold tracking-wider text-blue-900" }, " Jumlah Asesmen ", -1)
const _hoisted_5 = { class: "text-sm leading-6 text-gray-400" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm leading-6 font-semibold tracking-wider text-blue-900" }, " Tanggal Selesai ", -1)
const _hoisted_7 = { class: "text-sm leading-6 text-gray-400" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<hr class=\"my-4 border-gray-200\"><div class=\"mb-1 text-sm leading-6 font-semibold tracking-wider text-blue-900\"> List Asesmen </div><div class=\"flex justify-between mb-2\"><div class=\"text-sm leading-6 text-gray-400\">Asesmen</div><div class=\"text-sm leading-6 text-gray-400\">Total</div></div>", 3)
const _hoisted_11 = { class: "flex gap-4" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "text-blue-900 text-base leading-6 font-semibold tracking-wider" }
const _hoisted_14 = { class: "flex items-center gap-2 text-xs leading-5 text-gray-400" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-3 h-3"
}, null, -1)
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = { class: "text-sm leading-6 text-yellow-400 font-semibold tracking-wider" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-6 h-6"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2 border-gray-200" }, null, -1)
const _hoisted_20 = { class: "flex justify-end gap-4 p-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-base leading-6 font-semibold tracking-wider text-gray-900" }, " Total ", -1)
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = { class: "text-base leading-6 text-yellow-400 font-semibold tracking-wider" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-6 h-6"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.total_participants) + " Peserta ", 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.total_tests) + " Asesmen ", 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatDateTime(_ctx.data.ended_at)), 1)
      ])
    ]),
    _hoisted_8,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tests, (test) => {
      return (_openBlock(), _createElementBlock("div", {
        key: test.id,
        class: "flex justify-between border rounded-lg p-4 mb-2"
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: test.image,
            alt: `${test.name} image`,
            class: "w-14 h-14 bg-gray-300 rounded-full"
          }, null, 8, _hoisted_12),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(test.name), 1),
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(_toDisplayString(test.token) + " ", 1),
              _hoisted_15,
              _createTextVNode(" / Peserta ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(test.sub_total_token), 1),
          _hoisted_18
        ])
      ]))
    }), 128)),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.data.total_token), 1),
        _hoisted_24
      ])
    ])
  ], 64))
}